// project import
import dashboard from './dashboard';
import financeiro from './financeiro';
import intellivitta from './intellivitta';
import patients from './patients';
import support from './support';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, financeiro, intellivitta, patients, support]
};

export default menuItems;
